import { render, staticRenderFns } from "./CherkizovoElementNameTableColumn.vue?vue&type=template&id=b8e7f01a&scoped=true"
import script from "./CherkizovoElementNameTableColumn.vue?vue&type=script&lang=js"
export * from "./CherkizovoElementNameTableColumn.vue?vue&type=script&lang=js"
import style0 from "./CherkizovoElementNameTableColumn.vue?vue&type=style&index=0&id=b8e7f01a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8e7f01a",
  null
  
)

export default component.exports